import React from 'react';
import { faqs } from '../data/mockData';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';

const FAQSection = () => {
  return (
    <section id="faq" className="py-24 bg-white" data-testid="faq-section">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-zinc-500 mb-3">FAQ</p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#09090B]" style={{fontFamily:'Outfit,sans-serif'}}>
            Common Questions, Straight Answers
          </h2>
        </div>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-2">
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} className="bg-[#F4F4F5] rounded-lg px-6 border border-zinc-200 hover:border-[#002FA7] transition-colors duration-300" data-testid={`faq-item-${faq.id}`}>
                <AccordionTrigger className="text-left text-sm font-semibold text-[#09090B] hover:text-[#002FA7] py-5">{faq.question}</AccordionTrigger>
                <AccordionContent className="text-sm text-zinc-600 leading-relaxed pb-5">{faq.answer}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
